import { Injectable } from '@angular/core'
import { BehaviorSubject, Subject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class VideoService {
  public video = new BehaviorSubject<string>('')
  public offVideo = new Subject<any>()

  constructor() {}
}
